import { lazy } from "react";

export const FAQAsync = lazy(() => import("./FAQ"));
